import React from "react";
import SignInForm from "./sign-in-form.component";
import { useFormik } from "formik";
import useLoadingError from "src/hooks/useLoadingError";
import { useAppDispatch } from "src/store/hook";
import { loginSchema } from "src/validations/login-schema";
import { useLoginMutation } from "src/services/api-service/auth";
import { persistToken } from "src/utils";
import { setAuthToken, setUser } from "src/store/features/auth";
import { useNavigate } from "react-router-dom";
import { IResponse } from "src/services/types";
import { useGetAllCarriersMutation } from "src/services/api-service/quotations";

const SignInFormContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [getAllCarriers] = useGetAllCarriersMutation<any>();

  const { loading, error, reset, startLoading, stopLoading } =
    useLoadingError();
  const [login] = useLoginMutation<any>();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: (values) => {
      startLoading();
      login(values)
        .unwrap()
        .then((data) => {
          persistToken(data?.data?.access_token);
          dispatch(setUser(data?.data));
          dispatch(setAuthToken(data?.data?.access_token));
          getAllCarriers({});
          navigate("/admin/quotations");
        })
        .catch((err: IResponse) => {
          console.log(err);
        })
        .finally(() => {
          stopLoading();
        });
    },
  });

  return (
    <SignInForm
      formik={formik}
      error={error}
      resetError={reset}
      loading={loading}
    />
  );
};

export default SignInFormContainer;
